import React from 'react';
import emailIcon from '../../assets/email.png';
import successIcon from '../../assets/v1.png';
import { Dialog } from '../../components/Dialog';
import * as api from '../../services/api';
import en from '../../locales/en-US.json';
import zh from '../../locales/zh-Hans.json';
import urlparser from 'urlparser';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';
import './index.scss';
interface IProps {
  logo: string,
  inviterId: string;
  trailId: string;
  state:string;
}

interface IState {
  errMsg: string;
  showErr: boolean;
  email: string;
  lang: string;
  showDialog: boolean;
  message: any;
  jwt: string;
  time: string;
  custom: any;
  title: string;
  disabled: boolean;
  isWeChat: string;
  buttonUrl: string;
  logo:string;
  inviterId: string;
  trailId:string;
  state:string;
}

interface IParams {
  jwt: string;
  isWeChat: string;
  weChatButtonUrl: string;
  logo:string;
  inviterId: string;
}

export interface ITrialRes {
  time: number;
  error?: string;
  body?: {
    days: number;
  };
}

export class EnglishInvitePage extends React.Component<IProps, IState> {
  public readonly state: Readonly<IState> = {
    errMsg: '',
    showErr: false,
    email: '',
    lang: 'zh-Hans',
    showDialog: false,
    message: {
      'zh-Hans': zh,
      'en-US': en
    },
    jwt: '',
    time: '',
    custom: '',
    title: '',
    disabled: false,
    isWeChat: '',
    buttonUrl: '',
    logo:'',
    inviterId: '',
    trailId:'',
    state:''
  };

  UNSAFE_componentWillMount() {
    let url = urlparser.parse(window.location.href);
    let path = url.path.base;
    if (path.split('/')[1] === 'en') {
      this.setState({
        lang: 'en-US'
      });
    }
    let title = '';
    switch (path) {
      case 'trial/activity':
      case 'trial/activity-kw':
        title = 'iSlide VIP体验活动';
        break;
      case 'trial/bookActivity':
        title = 'iSlide 书籍活动';
        break;
      default:
        title = 'iSlide';
        break;
    }
    this.setState({
      title
    });

    if (path === 'trial/activity-kw') {
      let custom = require('../../assets/kw.png');
      this.setState({
        custom
      });
    }
  }

  componentDidMount() {
    this.setState(
      {
        trailId:this.props.trailId,
        logo: this.props.logo,
        inviterId:this.props.inviterId,
        state:this.props.state
      });
  }
  handleEmailChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      email: e.target.value
    });
  }

  async handleSubmit() {
    if (!this.state.email.trim()) {
      return this.setState({
        errMsg: 'Email is required',
        showErr: true
      });
    }

    let result: ITrialRes = await api.register(
      this.state.email.trim(),
      this.state.trailId,
      this.state.state,
      this.state.inviterId,
      'en-US'
    );

    this.setState({
      disabled: true
    });

    if (result.error) {
      return this.setState({
        disabled: false,
        errMsg: result.error,
        showErr: true
      });
    }
    if (result.body) {
      ReactGA.pageview(window.location.pathname+`/${result.body.days}days/email/success`);
      let date = result.body.days
      this.setState({
        time: `${date}`,
        showDialog: true
      });
    }
  }

  handleWechat = () => {
    if (!this.state.buttonUrl) {
      return;
    }
    // window.location.href = this.state.buttonUrl;
    window.open(this.state.buttonUrl)
  };

  render() {
    return (
      <div id="invite-english-page">
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        <section id="header">
          {/*{this.state.custom ? (*/}
          <div className="custom">
            {this.state.logo ?<p style={{background: 'url("https://static.islide.cc/web/img/ce8fd513d374490ae10dc08b3db107bb74d188c7.png") no-repeat bottom center',
              backgroundSize: '100% 1.5rem'}}> <img src={this.state.logo} alt=""/> <span>Office Special Offer</span></p>: this.state.custom ?
              <p style={{background: 'url("https://static.islide.cc/web/img/ce8fd513d374490ae10dc08b3db107bb74d188c7.png") no-repeat bottom center',
                backgroundSize: '100% 1.5rem'}}><img src={this.state.custom} alt=""/><span>Office Special Offer</span></p> : null}
          </div>
          {/*) : null}*/}
        </section>
        <section id="introduce">
          <div className="islide_intro">
            <h3>About iSlide</h3>
            <p>iSlide is a PowerPoint add-in.With</p>
            <p>38 design tools and 8 online resource libraries,it</p>
            <p>helps users make wow presentations easily!</p>
          </div>
          <div className="islide_device">
            <h3>Compatibility</h3>
            <div className="islide_device_box">
              <div className="islide_windows">
                <div><img src="https://static.islide.cc/web/img/987587a8e73d50f64aea0649d0832f503fb43e65.png" alt=""/></div>
                <p>PowerPoint / WPS</p>
                <p>for Windows</p>
              </div>
              <div className="islide_mac">
                <div><img src="https://static.islide.cc/web/img/215880d7a5d4146bfc832b4d6fdb4e5c274f6300.png" alt=""/></div>
                <p>PowerPoint</p>
                <p>for macOS</p>
              </div>
            </div>
          </div>
          <div className="islide_vip_right">
            <h3>Get Premium</h3>
            <div className="islide_right_intro">
              <div className="islide_right_box">
                <div><img src="https://static.islide.cc/web/img/07bd021f747ab4921cbfeebb5dc30d450181705e.png" alt=""/></div>
                <p>Vip Resources</p>
                <p>Access</p>
              </div>
              <div className="islide_right_box">
                <div><img src="https://static.islide.cc/web/img/292c6b06d48754b9178c38343f692cd91869368a.png" alt=""/></div>
                <p>Licensed</p>
                <p>Content</p>
              </div>
              <div className="islide_right_box">
                <div><img src="https://static.islide.cc/web/img/26baf04fb6b9001a0bcd11a0612fefe41ca61b21.png" alt=""/></div>
                <p>CUA for</p>
                <p>Individual</p>
              </div>
              <div className="islide_right_box">
                <div><img src="https://static.islide.cc/web/img/de03a5b5cda3fe31c96e5778b802ddf013cf8f1c.png" alt=""/></div>
                <p>Fast & Safe</p>
                <p>Download</p>
              </div>
              <div className="islide_right_box">
                <div><img src="https://static.islide.cc/web/img/4a90f61bd83079a87843bffd81db57b04dd48977.png" alt=""/></div>
                <p>Massive</p>
                <p>Resources</p>
              </div>
              <div className="islide_right_box">
                <div><img src="https://static.islide.cc/web/img/2bae12c9db677cc91686feeeb804b86da99a7f19.png" alt=""/></div>
                <p>Constant Resource</p>
                <p>Updates</p>
              </div>
            </div>
          </div>

        </section>
        <section id="form">
              <div className="form">
                <p className="err-message">{this.state.errMsg}</p>
                <div className="form-input">
                  <img className="email-icon" src={emailIcon} alt="email"/>
                  <input
                    onChange={this.handleEmailChange.bind(this)}
                    placeholder="Email Address"
                  />
                </div>
                <button
                  onClick={this.handleSubmit.bind(this)}
                  disabled={this.state.disabled}
                >
                  Get Membership Now
                </button>
              </div>
        </section>
        <Dialog
          visible={this.state.showDialog}
          onClose={() => {
            this.setState({
              showDialog: false,
              disabled: false
            });
          }}
        >
          <div className="dialog-success">
            <img src={successIcon} alt="success"/>
            <p className="message">Account Activated</p>
            <section className="footer">
              <p className="remark">
                Your experience membership duration is {this.state.time} days, please login in time.
              </p>
              <p className="remark" style={{ marginTop: '0.2rem' }}>
                Please check your email
              </p>
              <p className="remark" style={{ marginBottom: '0.4rem' }}>
                (May be mistaken for junk mail)
              </p>
            </section>
          </div>
        </Dialog>
      </div>
      //{' '}
    );
  }
}
